// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Roboto", sans-serif;
}

body.branding__l {
  --accentColor: #005591;
  --textOnAcccentColor: white;
}
body.branding__lf {
  --accentColor: #12BAED;
  --accentLightColor: rgba(18, 186, 237, 0.2);
  --textOnAcccentColor: white;
  --backgroundColor: #181818;
  --backgroudSecondaryColor: #01273c53;
  --textColor: white;
  --textSecondaryColor: lightgray;
  --grayColor: #ffffff7a;
  --grayLightColor: #ffffff2b;
}
body.branding__cp {
  --accentColor: #01497C;
  --accentLightColor: rgba(1, 73, 124, 0.1);
  --textOnAcccentColor: white;
}
body.branding__jrc {
  --accentColor: #000000;
  --textOnAcccentColor: white;
}
body {
  background-color: var(--backgroundColor);
  color: var(--textColor);
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAAF;;AAGA;EACE,iCAAA;AAAF;;AAME;EACE,sBAAA;EACA,2BAAA;AAHJ;AAOE;EACE,sBAAA;EACA,2CAAA;EACA,2BAAA;EACA,0BAAA;EACA,oCAAA;EACA,kBAAA;EACA,+BAAA;EACA,sBAAA;EACA,2BAAA;AALJ;AASE;EACE,sBAAA;EACA,yCAAA;EACA,2BAAA;AAPJ;AAWE;EACE,sBAAA;EACA,2BAAA;AATJ;AAtBA;EAkCE,wCAAA;EACA,uBAAA;AATF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Roboto', sans-serif;\n}\n\nbody {\n\n  // Linde Branding\n  &.branding__l {\n    --accentColor: #005591;\n    --textOnAcccentColor: white;\n  }\n\n  // LeaseForce Branding\n  &.branding__lf {\n    --accentColor: #12BAED;\n    --accentLightColor: rgba(18, 186, 237, 0.2);\n    --textOnAcccentColor: white;\n    --backgroundColor: #181818;\n    --backgroudSecondaryColor: #01273c53;\n    --textColor: white;\n    --textSecondaryColor: lightgray;\n    --grayColor: #ffffff7a;\n    --grayLightColor: #ffffff2b;\n  }\n\n  // coPetence Branding\n  &.branding__cp {\n    --accentColor: #01497C;\n    --accentLightColor: rgba(1, 73, 124, 0.1);\n    --textOnAcccentColor: white;\n  }\n\n  // JRC Branding\n  &.branding__jrc {\n    --accentColor: #000000;\n    --textOnAcccentColor: white;\n  }\n\n  background-color: var(--backgroundColor);\n  color: var(--textColor);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
